import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { ElderShellService } from '@elderbyte/ngx-starter'
import { NumberSequence } from '../number-sequence'
import { NumberSequenceDetailComponent } from '../number-sequence-detail/number-sequence-detail.component'

@Component({
  selector: 'app-number-sequence-detail-side',
  templateUrl: './number-sequence-detail-side.component.html',
  styleUrls: ['./number-sequence-detail-side.component.scss'],
  imports: [NumberSequenceDetailComponent],
})
export class NumberSequenceDetailSideComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public sequence: NumberSequence
  private route = inject(ActivatedRoute)
  private shellService = inject(ElderShellService)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    this.sequence = this.route.snapshot.data['numberSequence']
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public onClose(event: Event): void {
    this.shellService.closeSideContent()
  }
}
